import { useMutation } from "@tanstack/react-query";
import { getFunctions, httpsCallable } from "firebase/functions";

import { useInvalidateCalendarsForTables } from "./useCalendarsForTables";

export function useDeleteCalendars() {
  const invalidateCalendarTable = useInvalidateCalendarsForTables();

  return useMutation({
    mutationFn: async (calendarIds) => {
      if (!Array.isArray(calendarIds)) {
        throw new Error("Calendars IDs must be a non-empty array.");
      }

      const functions = getFunctions(undefined, "europe-west2");
      const deleteCalendars = httpsCallable(functions, "deleteCalendars");
      const result = await deleteCalendars({ calendarIds });

      return result.data;
    },
    onSuccess: (data) => {
      if (data.success) {
        invalidateCalendarTable();
      }
    },
    onError: (error) => {
      console.error("Failed to delete calendars", error);
    },
  });
}
